module.exports = __webpack_public_path__ + "img/buildings-no-disclosures.fbc375f5.svg";